import { Household } from '../../HouseholdTypes';

interface EventResponses {
  accepted: number;
  declined: number;
  noResponse: number;
  total: number;
}

export const getRSVPResponses = (eventId: string, households: Household[]): EventResponses => {
  let accepted = 0;
  let declined = 0;
  let noResponse = 0;
  let total = 0;
  if (!households) {
    return { accepted, declined, noResponse, total };
  }
  households.forEach(household => {
    if (household.people) {
      household.people.forEach(person => {
        if (person.invitations) {
          const invitation = person.invitations.find(i => i.eventId === eventId);
          if (invitation) {
            if (invitation.rsvp === true) {
              accepted += 1;
            } else if (invitation.rsvp === false) {
              declined += 1;
            } else {
              noResponse += 1;
            }
          }
        }
      });
    }
  });
  total = accepted + declined + noResponse;
  return { accepted, declined, noResponse, total };
};

export const buildGLMUrl = (eventId?: string): string => {
  const { hostname, protocol } = window.location;
  let domain = `${protocol}//qa-beta.theknot.com`;

  //if prod use the prod domain
  if (hostname === 'www.theknot.com') {
    domain = 'https://www.theknot.com';
  }
  const url = new URL(domain);
  url.pathname = '/our-guest-list';
  if (eventId) {
    url.searchParams.append('event', eventId);
  }
  return url.href;
};

export const buildRSVPUrl = (): string => {
  const { hostname, protocol } = window.location;
  let domain = `${protocol}//qa-beta.theknot.com`;

  //if prod use the prod domain
  if (hostname === 'www.theknot.com') {
    domain = 'https://www.theknot.com';
  }
  const url = new URL(domain);

  if (hostname === 'www.theknot.com') {
    url.pathname = '/our-guest-list/rsvps';
  } else {
    url.pathname = '/new-guest-list/rsvps';
  }

  return url.href;
};
